import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

// import { useCurrentWidth } from 'react-socks';
import cx from 'classnames';
import { Mousewheel, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';

import { Footer } from 'layouts';

import { setSlideIdx } from 'store/system/slice';

import styles from 'styles/styles.module.scss';

import './PageSwiper.scss';

const PageSwiper = ({ wrapperClassName, swiperInfo, children }) => {
    // const breakpointWidth = useCurrentWidth();
    const dispatch = useDispatch();
    const [swipeIndex, setswipeIndex] = useState(0);

    // console.log(
    //     'breakpointWidth: ',
    //     breakpointWidth >= styles.DESKTOP_BREAKPOINT
    // );

    /** @type {React.MutableRefObject<Element | null>}*/
    const swiperRef = useRef(null);

    useEffect(() => {
        const updateSwiperTheme = () => {
            const currentBulletTheme =
                swiperInfo[swipeIndex]?.bulletTheme ?? '';
            const swiperPaginations = swiperRef.current.children[1].children;

            for (/** @type {Element} */ const pagination of swiperPaginations) {
                pagination.className = pagination.className.replace(
                    'primary',
                    ''
                );
                pagination.className = pagination.className.replace(
                    'secondary',
                    ''
                );
                pagination.className = `${pagination.className} ${currentBulletTheme}`;
            }
        };

        updateSwiperTheme();
    }, [swipeIndex, swiperInfo]);

    return (
        <Swiper
            ref={swiperRef}
            direction={'vertical'}
            slidesPerView={1}
            spaceBetween={0}
            mousewheel={true}
            preventInteractionOnTransition={true}
            speed={1300}
            delay={5000}
            pagination={{
                clickable: true
            }}
            modules={[Mousewheel, Pagination]}
            onSlideChange={({ activeIndex }) => {
                setswipeIndex(activeIndex);
                dispatch(setSlideIdx(activeIndex));
            }}
            breakpoints={{
                0: {
                    slidesPerView: 8
                },
                [styles.DESKTOP_BREAKPOINT]: {
                    slidesPerView: 1
                }
            }}
            // onResize={(swiper) => {
            //     // console.log('onResize: ', swiper);
            //     if (breakpointWidth < styles.DESKTOP_BREAKPOINT) {
            //         console.log('destroySwiper');
            //         swiper.destroy(true, true);
            //         // swiper.disable();
            //     } else {
            //         console.log('reinitialized');
            //         swiper.init();
            //         // setSwiperKey(new Date().getTime());
            //     }
            //     // if (window.innerWidth <= 768) {
            //     //     swiper.destroy(true, true);
            //     // }
            // }}
            className={cx(['pageSwiper', wrapperClassName])}>
            {swiperInfo.map((item, index) => (
                <SwiperSlide key={index}>{item.component}</SwiperSlide>
            ))}
            {children}
            <SwiperSlide>
                <Footer fullscreen />
            </SwiperSlide>
        </Swiper>
    );
};

export default PageSwiper;
